import * as React from 'react';

import { ReactComponent as EmptyIcon } from '@/assets/svg/empty.svg';
import { $gt } from '@/common/appCtx';

import styles from './index.module.less';

export interface EmptyProps {
  className?: string;
  text?: string;
  style?: React.CSSProperties;
}

const Empty: React.FC<EmptyProps> = (props)=> {
  return (
    <div
      style={props.style}
      className={styles.empty}
    >
      <EmptyIcon />
      <div className={styles.text}>
        {props.text || $gt('No Data')}
        </div>
    </div>
  );
};

export default Empty;
